<template>
  <section v-editable="blok" hero-bold :style="[bgStyle]">
    <div class="container container--bleed">
      <div class="section-row">
        <div class="section-content">
          <h1 v-if="blok.title" class="section-title" v-html="blok.title"></h1>
          <div v-if="blok.description" class="section-description" v-html="blok.description"></div>
          <div v-if="blok.buttons" class="section-buttons">
            <StoryblokComponent v-for="blok in blok.buttons" :key="blok._uid" :blok="blok" />
          </div>
        </div>

        <div class="section-image">
          <img v-if="blok.image?.filename" :src="optimizeImage(blok.image.filename)" alt="Hero Banner Image" loading="lazy" />

          <div v-if="blok?.video?.length > 0" class="section-video">
            <video loop muted playsInline class="w-auto h-full" autoplay :poster="optimizeImage(blok.image.filename)">
              <source v-for="(source, index) in videoSources" :key="index" :src="source.url" :type="source.type" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
  const props = defineProps({ blok: Object });

  useHead({
    link: [
      {
        rel: "preload",
        as: "image",
        fetchpriority: "high",
        href: optimizeImage(props.blok.background?.filename),
      },
      {
        rel: "preload",
        as: "video",
        href: props.blok?.video,
        type: "video/webm",
      },
    ],
  });

  const bgStyle = computed(() => {
    if (!props.blok.background?.filename) return {};
    return {
      backgroundImage: `url(${props.blok.background?.filename})`,
      backgroundColor: props.blok?.background_color?.color || "#FFF",
    };
  });

  const dimensions = (image) => {
    if (image) {
      const urls = image?.filename?.split("/")[5].split("x");
      return {
        width: urls[0],
        height: urls[1],
      };
    }
    return { width: 0, height: 0 };
  };

  const getVideoSources = (videoString) => {
    if (!videoString) return [];
    return videoString.split(",").map((url) => {
      const extension = url.split(".").pop();
      let type = "";
      switch (extension) {
        case "webm":
          type = "video/webm";
          break;
        case "mov":
          type = "video/quicktime";
          break;
        default:
          type = "";
      }
      return { url, type };
    });
  };

  const videoSources = computed(() => getVideoSources(props.blok?.video));
</script>
<style src="~/assets/scss/section/hero-bold.scss" lang="scss"></style>
